import React, { useEffect } from "react";

import "@styles/readers.scss";
import { Div, Button } from "@components/Generics.react";
import Accordion from "@components/Accordion.react";
import * as DOMPurify from "dompurify";

export default function FAQReader(props) {
    const { deck, recordAttempt } = props;

    //---------------------------------------------------------------------------
    // Completion Tracking
    //---------------------------------------------------------------------------
    useEffect(() => {
        recordAttempt({
            viewedPercentage: 100,
            completion: true,
            pointsDelta: 0,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let panels =
        typeof deck?.content === "string" || deck?.content instanceof String
            ? [
                  {
                      title: <Div small>Answer:</Div>,
                      content: (
                          <div
                              dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(deck?.content),
                              }}
                          />
                      ),
                  },
              ]
            : deck?.content.map((item) => {
                  return {
                      title: <Div small>{item?.title}</Div>,
                      content: (
                          <Div>
                              <div
                                  dangerouslySetInnerHTML={{
                                      __html: DOMPurify.sanitize(
                                          item?.description
                                      ),
                                  }}
                              />
                              <br />
                              {item?.button && (
                                  <a href={item?.button.btnLink}>
                                      <Button
                                          primary
                                          fluid
                                          content={item?.button.text}
                                      />
                                  </a>
                              )}
                          </Div>
                      ),
                  };
              });

    return (
        <Div
            fluid
            fullht
            noOverflow
            rounded
            left-align
            slightShadow
            className="faq-reader"
        >
            <Accordion panels={panels}></Accordion>
        </Div>
    );
}
